<template>
<div v-if="!column_superseded" :class="'column is-' + col_size">
    <div class="bg-white team-member">
        <router-link :to="item.url" class="is-block">
            <figure class="team-member__portrait" v-if="item.image">
                <template v-if="image || alt_image">
                    <img v-if="image" :alt="image.title" class="is-block" :src="image.url" />
                    <img v-if="alt_image" class="is-block alt-portrait" :alt="alt_image.title" :src="alt_image.url" />
                </template>
                <button v-else class="button is-loading is-white is-large" disabled></button>
            </figure>
        </router-link>
        <div class="team-member__details has-text-centered">
            <h3 :class="['title', {'is-marginless': item.role}]">{{item.title}}</h3>
            <p v-if="item.role" class="title">{{item.role}}</p>
            <p class="content excerpt" v-if="item.excerpt">
                {{item.excerpt}}
            </p>
            <p class="content" v-if="item.url">
                <router-link :to="item.url">View Profile</router-link>
            </p>
        </div>
    </div>
</div>
<div v-else class="bg-white team-member">
    <router-link :to="item.url" class="is-block">
        <figure class="team-member__portrait" v-if="item.image">
            <template v-if="image || alt_image">
                <img v-if="image" :alt="image.title" class="is-block" :src="image.url" />
                <img v-if="alt_image" class="is-block alt-portrait" :alt="alt_image.title" :src="alt_image.url" />
            </template>
            <button v-else class="button is-loading is-white is-large" disabled></button>
        </figure>
    </router-link>
    <div class="team-member__details has-text-centered">
        <h3 :class="['title', {'is-marginless': item.role}]">{{item.title}}</h3>
        <p v-if="item.role" class="title">{{item.role}}</p>
        <p class="content excerpt" v-if="item.excerpt">
            {{item.excerpt}}
        </p>
        <p class="content" v-if="item.url">
            <!-- <a :href="item.url" target="_blank">View LinkedIn profile</a> -->
            <router-link :to="item.url">View Profile</router-link>
        </p>
    </div>
</div>
</template>

<script>
import WindowResizeHandler from '@/components/mixins/WindowResizeHandler';
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name        :   'TeamMember',
    props       :   ['item'],
    data()
    {
        return {
            col_size: 4,
            image: this.item && (typeof this.item.image === 'object') ? this.item.image : null,
            alt_image: this.item && (typeof this.item.alt_image === 'object') ? this.item.alt_image : null,
        }
    },
    mixins      :   [ WindowResizeHandler, ViewBlockItemMixin ],
    methods :   {
        handle_window_resize(width)
        {
            if (width < 641) {
                this.col_size   =   12;
            } else {
                this.col_size   =   4;
            }
        }
    },
    mounted() {
        if (this.item) {
            if (!this.image && this.item.image && (typeof this.item.image === 'number')) {
                axios
                    .get(`/image-gen/${this.item.image}`)
                    .then(resp => {
                        this.image = resp.data
                    })
            }

            if (!this.alt_image && this.item.alt_image && (typeof this.item.alt_image === 'number')) {
                axios
                    .get(`/image-gen/${this.item.alt_image}`)
                    .then(resp => {
                        this.alt_image = resp.data
                    })
            }
        }
    },
}
</script>
<style lang="scss">
.team-member__portrait {
    .button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/TeamMember.vue